import { useMemo } from 'react';
import i18n from 'Utilities/i18n';
import useTheme from './useTheme';
const useThemedResource = resourceKey => {
  const {
    theme
  } = useTheme();
  return useMemo(() => {
    const mainKey = resourceKey.replace(/(light|dark)$/i, '');
    const themeSuffix = theme === 'light' ? 'Light' : 'Dark';
    const localeSuffix = i18n.language.split('-')[0].toUpperCase();
    const candidates = [`${mainKey}${themeSuffix}_${localeSuffix}`, `${mainKey}_${localeSuffix}`, `${mainKey}${themeSuffix}`];
    const validKey = candidates.find(key => i18n.exists(key)) ?? resourceKey;
    return {
      key: validKey,
      src: i18n.t(validKey)
    };
  }, [resourceKey, theme]);
};
export default useThemedResource;